import React from 'react';
import { useDispatch } from 'react-redux';
import { I_TodayMoreGroup } from '@Redux/detail/Group/interfaces';
import * as Tag from '@components/Common/Tag';
import { changeDetailHistory } from '@utils/utils';
import DirectionList from './DirectionList';
import styles from '../styles.module.scss';
import { setGroupDetail, setStationInfo } from '@Redux/detail/Group/actions';
import { setOptionalInfo, setNoticeinfo } from '@Redux/detail/Itineraries/actions';
import cN from 'classnames';
import { useTranslation } from 'react-i18next';

interface I_Props {
    todayMoreList: I_TodayMoreGroup[];
    triggerLightBox?: any;
    NormGroupID?: string;
    TourSource: string;
}

const TodayMoreGroupList: React.FC<I_Props> = ({
    todayMoreList,
    TourSource,
    NormGroupID,
    triggerLightBox,
}) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const changeGroup = (data: I_TodayMoreGroup) => {
        const reqBody = {
            GroupID: data.GroupID,
            TourSource,
        };

        dispatch(setGroupDetail(reqBody));
        dispatch(setStationInfo(reqBody));
        dispatch(setOptionalInfo(reqBody));
        dispatch(setNoticeinfo(reqBody));
        NormGroupID && changeDetailHistory({ NormGroupID, GroupID: data.GroupID });
        triggerLightBox();
    };

    function adjustStatusName(group: I_TodayMoreGroup) {
        switch (group.StatusName) {
            case '報名':
                return '可報名';
            case '關團':
                return t('closeGroup');
            default:
                return group.StatusName;
        }
    }

    return (
        <ul className={styles.listWrap}>
            {todayMoreList?.map((group: I_TodayMoreGroup, i: number) => (
                <li
                    key={'more' + i}
                    className={cN(styles.group, styles.trigger)}
                    onClick={() => changeGroup(group)}
                >
                    <div className={styles.basics}>
                        <div className={styles.tags}>
                            <Tag.Normal text={adjustStatusName(group)} />
                            {group.IsEnsureGroup && (
                                <Tag.Normal text={t('IsEnsureGroup')} className="isEnsureGroup" />
                            )}
                            {group.IsVip && <Tag.Featured text="會員限購" isHalfRadius />}
                        </div>
                        <div className={styles.groupID}>
                            {t('GroupID')}：{group.GroupID}
                        </div>
                        <div className={styles.seats}>
                            <div>可賣：{group.QuotaSeats}</div>
                            <div>
                                {t('seats')}:{group.TotalSeats}
                            </div>
                        </div>
                        <div className={styles.price}>
                            <span>
                                {group.Status == 6
                                    ? '近期上架'
                                    : `${group.CurrencyCode || ''} ${group.StraightLowestPrice}`}
                            </span>
                            人/起
                        </div>
                    </div>
                    {Array.isArray(group.DirectionList) && group.DirectionList.length > 0 && (
                        <div className={styles.flights}>
                            <DirectionList directions={group.DirectionList} />
                        </div>
                    )}
                </li>
            ))}
        </ul>
    );
};

export default TodayMoreGroupList;
